var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "31px",
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Round/Entries-(1)",
    transform: "translate(-738.000000, -261.000000)",
    fill: "#015597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(660.146203, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.853797, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0926966,21.7 L60.2106742,21.7 L60.2106742,9.3 L57.0926966,9.3 L57.0926966,21.7 Z M61.7696629,0 C53.1640449,0 46.1797753,6.944 46.1797753,15.5 C46.1797753,24.056 53.1640449,31 61.7696629,31 C70.3752809,31 77.3595506,24.056 77.3595506,15.5 C77.3595506,6.944 70.3752809,0 61.7696629,0 L61.7696629,0 Z M61.7696628,28.8884685 C54.3432724,28.8884685 48.2977528,22.8778059 48.2977528,15.4942342 C48.2977528,8.11066262 54.3432724,2.1 61.7696628,2.1 C69.1960532,2.1 75.2415728,8.11066262 75.2415728,15.4942342 C75.2415728,22.8778059 69.1960532,28.8884685 61.7696628,28.8884685 L61.7696628,28.8884685 Z M63.3286517,21.7 L66.4466292,21.7 L66.4466292,9.3 L63.3286517,9.3 L63.3286517,21.7 Z",
    id: "Fill-115"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircle);
export default __webpack_public_path__ + "static/media/PauseCircle.993f1add29ff1882efb9fb660995c1a7.svg";
export { ForwardRef as ReactComponent };